import user from "../../../../../js/user.js";

export default () => {
  if (!user.isLogged && !user.isPartner) {
    $('.article-page__mssg--partner_advice').remove();
    return;
  }

  if ($('.article-page__mssg--partner_advice').data('advancedDate') <= new Date().getTime() / 1000) {
    $('.article-page__mssg--partner_advice').remove();
  }

  $('.article-page__mssg--partner_advice .mssg--partner_advice__close').on('click', function(){
    $('.article-page__mssg--partner_advice').remove();
  });
}
